import { Box, styled, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material/styles'

import useLanguagePreferenceSaver from 'app/hooks/useLanguagePreferenceSaver'
import languageFlag from 'app/images/header/language-flag.svg'
import { EnglishLanguageKey, FrenchLanguageKey } from 'app/locales'
import useTracking from 'app/tracking/useTracking'
import { ANALYTICS_OBJECTS } from 'app/utils/constants'

export const ImgStyle = styled('img')({
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'inline',
    paddingRight: '4px',
    verticalAlign: 'middle'
})

export function LocaleSwitcher() {
    const { i18n, t } = useTranslation()
    const { trackClick } = useTracking()
    const { saveLanguagePreferenceInOrigination, saveLanguagePreferenceInPrequal } = useLanguagePreferenceSaver()
    const theme = useTheme()
    const displayLanguage = i18n.resolvedLanguage === EnglishLanguageKey ? 'FR' : 'EN'

    const handleLanguageToggle = async () => {
        const newLanguage = i18n.resolvedLanguage === EnglishLanguageKey ? 'French' : 'English'
        const newLanguageKey = i18n.resolvedLanguage === EnglishLanguageKey ? FrenchLanguageKey : EnglishLanguageKey

        // Track the language change
        trackClick(`${ANALYTICS_OBJECTS.LANGUAGE_SWITCHER}: ${newLanguage}`)

        // Change the language
        i18n.changeLanguage(newLanguageKey)

        // Save preference if needed (hook handles all the logic)
        await saveLanguagePreferenceInOrigination(newLanguageKey)
        await saveLanguagePreferenceInPrequal(newLanguageKey)
    }

    return (
        <Box
            onClick={handleLanguageToggle}
            sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center'
            }}
            data-testid="localeSwitcher"
        >
            <ImgStyle src={languageFlag} alt={t('common.alt.languageFlag')} height="20px" data-testid="flagIcon" />
            <Typography
                style={{
                    color: theme.color.figGreen,
                    fontWeight: 500,
                    paddingLeft: '4px'
                }}
            >
                {displayLanguage}
            </Typography>
        </Box>
    )
}
